import {
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { ChangeEvent, useEffect, useLayoutEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../../../store/auth.store";
import { LoadingPage } from "../../../utils/components/LoadingPage";

export function ResetPasswordCode() {
    const { setUserBrowserData, accessToken, logout, refresh, sendCode } = useAuthStore();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:700px)");
    const [searchParams, setSearchParams] = useSearchParams();
    const hash = searchParams.get("hash");
    if (!hash)
        return (
            <Box
                sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "30px",
                }}
            >
                <Paper
                    sx={{
                        padding: "40px",
                        margin: "0 40px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                        gap: "8px",
                    }}
                >
                    <h1>Не найден уникальный код</h1>
                    <Button to={"/"} variant="contained" component={Link}>
                        На главную
                    </Button>
                </Paper>
            </Box>
        );

    // Проверка авторизации и редирект на главную страницу, если авторизован
    const [loadingIsAuth, setLoadingIsAuth] = useState(false);
    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingIsAuth(true);
                if (accessToken) {
                    const isAuthed = await refresh();
                    console.log(isAuthed);
                    if (isAuthed) location.href = "/admin";
                }
            } catch (error) {
                logout();
            } finally {
                setLoadingIsAuth(false);
            }
        })();
    }, []);

    useEffect(() => {
        setUserBrowserData(navigator.userAgent);
    }, []);

    const [error, setError] = useState("");
    const [code, setCode] = useState("");
    const handleChangeCode = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setCode(event.target.value.trim());
        if (event.target.value.trim() == "")
            setError("Введите специальный код");
        else setError("");
    };

    const handleSendCode = async () => {
        try {
            if (code == "")
                setError("Введите специальный код");
            else setError("");
            const response = await sendCode(code, hash);
            if (response) navigate("/resetpassword/change");
        } catch (error) {}
    };

    if (loadingIsAuth) return <LoadingPage />;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "40px",
                    margin: "0 40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                    gap: "8px",
                }}
            >
                <h1>Восстановление пароля</h1>
                <Typography>
                    На вашу почту пришёл специальный код. Введите его в поле
                    ниже для продолжения
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        gap: "8px",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <TextField
                        placeholder="Специальный код"
                        sx={{
                            flex: 1,
                        }}
                        value={code}
                        onChange={handleChangeCode}
                        error={error != ""}
                        helperText={error}
                    />
                    <Button
                        variant="contained"
                        sx={{
                            maxHeight: "56px",
                        }}
                        onClick={handleSendCode}
                    >
                        Отправить
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}
